var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
import cx from 'classnames';
const SvgIconComponent = (props, ref) => ((props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 40,
  height: 40,
  fill: "none",
  viewBox: "0 0 40 40",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "url(#a)",
  fillRule: "evenodd",
  d: "M20 40c11.046 0 20-8.954 20-20S31.046 0 20 0 0 8.954 0 20s8.954 20 20 20M10 27.57q0 .083.01.165c.115 1.263 1.15 2.257 2.414 2.265.37.002.72-.08 1.036-.229l6.298-3.348c.04-.022.123-.075.179-.112l.053-.034 6.55 3.472c.324.152.678.23 1.036.227 1.187-.007 2.172-.883 2.382-2.035a1.3 1.3 0 0 0 .042-.325V12.43q0-.085-.01-.165c-.115-1.263-1.15-2.257-2.414-2.265a2.4 2.4 0 0 0-1.036.23l-6.298 3.347c-.04.022-.123.076-.18.113l-.052.034-6.55-3.472a2.4 2.4 0 0 0-1.035-.228c-1.188.008-2.173.883-2.383 2.036a1.3 1.3 0 0 0-.042.323v15.188Zm10.01-13.847.005.003zm-1.22 10.38-5.657 3.014a.5.5 0 0 1-.19.038.51.51 0 0 1-.504-.516V13.385a.513.513 0 0 1 .505-.517.5.5 0 0 1 .188.038l5.174 2.724a4.5 4.5 0 0 0-.42 2.049c.023.811.265 1.601.7 2.285l.833 1.504-.005.003c.164.282.254.601.263.928a1.96 1.96 0 0 1-.887 1.705Zm-.484-8.473.009.004-.009-.006zm9.255 9.352v1.633a.513.513 0 0 1-.505.517.5.5 0 0 1-.189-.038l-5.174-2.722c.3-.64.444-1.343.421-2.05a4.5 4.5 0 0 0-.7-2.287l-.833-1.503.006-.002h-.001a2 2 0 0 1-.263-.928 1.96 1.96 0 0 1 .887-1.705l5.657-3.013a.5.5 0 0 1 .19-.038.51.51 0 0 1 .504.515v1.633h.002v9.988z",
  clipRule: "evenodd"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "a",
  x1: -12.628,
  x2: 64,
  y1: 53.13,
  y2: -13.5,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.32,
  stopColor: "#1A87E5"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.609,
  stopColor: "#4BACFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#6590FF"
}))))))({
  ...props,
  className: cx('PA-Svg', props.className)
}, ref);
const SvgOnline = SvgIconComponent;
const ForwardRef = /*#__PURE__*/forwardRef(SvgOnline);
export default ForwardRef;